import { DtoExtension } from '@/shared/constants/dto';

const EXTENSION_TO_MIME_TYPE: Partial<Record<DtoExtension, string>> = {
  // VIDEO
  [DtoExtension.mp4]: 'video/mp4',
  [DtoExtension.mov]: 'video/quicktime',
  [DtoExtension.avi]: 'video/x-msvideo',
  [DtoExtension.mkv]: 'video/x-matroska',
  [DtoExtension.mxf]: 'application/mxf',
  [DtoExtension.ts]: 'video/mp2t',
  // AUDIO
  [DtoExtension.mp3]: 'audio/mpeg',
  [DtoExtension.wav]: 'audio/wav',
  [DtoExtension.aac]: 'audio/aac',
  // IMAGE
  [DtoExtension.jpeg]: 'image/jpeg',
  [DtoExtension.jpg]: 'image/jpeg',
  [DtoExtension.png]: 'image/png',
  [DtoExtension.gif]: 'image/gif',
  [DtoExtension.webp]: 'image/webp',
  // FONT
  [DtoExtension.ttf]: 'font/ttf',
  [DtoExtension.otf]: 'font/otf',
  [DtoExtension.woff]: 'font/woff',
  [DtoExtension.woff2]: 'font/woff2',
  // DOC
  [DtoExtension.pdf]: 'application/pdf',
};

/**
 * DtoExtension 코드에서 표준 MIME 타입을 가져옵니다.
 *
 * `FileExtensionValue` 는 `DtoExtension` 의 부분집합이므로 그대로 전달 가능합니다.
 *
 * S3 응답의 Content-Type 헤더가 `application/x-www-form-urlencoded` 같이
 * 잘못 내려오는 경우 권위적 소스인 API extension 으로 mimeType 을 결정하기 위한 매핑.
 *
 * @returns 매핑된 MIME 타입. 알 수 없으면 undefined.
 */
export const getMimeTypeFromExtension = (
  extension: DtoExtension | null | undefined,
): string | undefined => {
  if (extension == null) return undefined;
  return EXTENSION_TO_MIME_TYPE[extension];
};
